import * as React from 'react';
import { cn } from '@soundbyte/config';

interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md' | 'lg';
}

const sizeClasses = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-8 w-8 border-3',
};

const Spinner = React.forwardRef<HTMLDivElement, SpinnerProps>(
  ({ className, size = 'md', ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'animate-spin rounded-full border-primary border-t-transparent',
          sizeClasses[size],
          className
        )}
        {...props}
      />
    );
  }
);
Spinner.displayName = 'Spinner';

// Full page loading spinner
const PageSpinner = () => (
  <div className="flex h-screen w-full items-center justify-center">
    <Spinner size="lg" />
  </div>
);

// Section loading spinner
const SectionSpinner = ({ text }: { text?: string }) => (
  <div className="flex flex-col items-center justify-center py-12">
    <Spinner size="lg" />
    {text && <p className="mt-4 text-sm text-muted-foreground">{text}</p>}
  </div>
);

export { Spinner, PageSpinner, SectionSpinner };
